<template>
  <SectionPage :img="img" :content="content" :btn="btn" :icon="icon"/>
</template>

<script>
import SectionPage from '@/layout/SectionPage.vue'
export default {
  name: "Section1",
  components: {
    SectionPage
  },
  data() {
    return {
      img: require('@/assets/section-bg/section1.jpg'),
      content: {
        componentsType: {
          pc: 'shortBtn sectionBtn',
          mobile: 'shortBtn sectionBtn'
        },
        title: '01\nBASICS',
        text: 'Start by giving us some basic information about yourself so we understand where you are in your path to wellness.'
      },
      btn:{
        text: 'Next',
        link: '/questionnaire/section1/1',
      },
      icon: require('@/assets/icon/section-01.png')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
